import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import CreateThread from './CreateThread';
import FeedbackUserManagement from './FeedbackUserManagement';

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: "auto",
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

export default function SimpleModal({
    closeModal, modalTitle, submitForm, currentUser, currentUserId, currentUserRole,loadData,modalMode,thread}) {
    const classes = useStyles();
    // getModalStyle is not a pure function, we roll the style only on the first render
    const [modalStyle] = React.useState(getModalStyle);
    const [date, setDate] = React.useState(new Date());
    return (
        <Modal
            open={true}
            onClose={closeModal}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            <div style={modalStyle} className={classes.paper}>
                <h2 style={{textAlign:"center",marginBottom:"20px"}}>{modalTitle}</h2>
         
                {modalMode === "threads" ? <CreateThread currentUser={currentUser} currentUserId={currentUserId} currentUserRole={currentUserRole} closeModal={closeModal} loadData={loadData}/> : 
                <FeedbackUserManagement thread={thread} currentUserId={currentUserId} currentUser={currentUser} closeModal={closeModal} /> }
            </div>
        </Modal>
    );
}
